import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi) // Load translations from files
  .use(LanguageDetector) // Detect language (from browser or manually set)
  .use(initReactI18next) // Passes i18n to react-i18next
  .init({
    supportedLngs: ["en", "fr", "de"], // Supported languages
    fallbackLng: "en", // Fallback language if no translation is found
    detection: {
      order: ["path", "cookie", "htmlTag", "localStorage", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Path to translation files
    },
    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;
